import type { ChangeEvent } from "react";
import type {
	UseFormReturn,
	FieldValues,
	Path,
	PathValue,
} from "react-hook-form";
import { FormTextArea } from "./form-textarea.components";

interface PrefixTextAreaProps<T extends FieldValues> {
	prefix?: string;
	form: UseFormReturn<T>;
	name: Path<T>;
	label: string;
	placeholder?: string;
	required?: boolean;
}

const PrefixTextArea = <T extends FieldValues>({
	prefix,
	form,
	name,
	label,
	placeholder,
	required,
}: PrefixTextAreaProps<T>) => {
	const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		const value = e.target.value;

		const formattedText = value
			.split(" ")
			.map((word) =>
				word.startsWith(prefix ? prefix : "") || word === ""
					? word
					: `${prefix}${word}`,
			)
			.join(" ");

		form.setValue(name, formattedText as PathValue<T, Path<T>>);
	};

	return (
		<FormTextArea
			form={form}
			name={name}
			label={label}
			placeholder={placeholder || ""}
			required={required}
			onChange={handleChange}
		/>
	);
};

export default PrefixTextArea;
